import React from "react";
import Themes from "@/components/Themes";

const StorefrontThemesPreview = () => {
  return <Themes />;
};

export default StorefrontThemesPreview;